/**
 * Created by Ning Jiang on 2024-03-19.
 */

import {DeadwoodRipSymbol} from "./DeadwoodRipSymbol";
import {DeadwoodRipSymbolState} from "./DeadwoodRipSymbolConfig";
import {TimelineLite} from "gsap";
import {DeadwoodRip} from "../DeadwoodRip";

export class CylinderSymbol extends DeadwoodRipSymbol {

    constructor(reelId:number, initState:DeadwoodRipSymbolState) {
        super("C", reelId, initState);
    }

    public playLanding(init:boolean = false):TimelineLite {
        const tl = new TimelineLite();
        tl.add(DeadwoodRip.cylinderController.load(this));
        return tl;
    }

    public split(type:number, noWin:boolean):TimelineLite {
        return new TimelineLite();
    }

    public playOnShot():TimelineLite {
        return new TimelineLite();
    }

    public kill():TimelineLite {
        return new TimelineLite();
    }
}